var _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMesh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_21513_23446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.355469,
    width: 66.2567,
    height: 65.4679,
    rx: 10.254,
    fill: "#898989"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_b_21513_23446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.355469,
    y: 49.6914,
    width: 66.2567,
    height: 15.7754,
    rx: 7.8877,
    fill: "#FCB0B2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.2967 50.1427C23.8151 50.1427 23.4258 49.7737 23.4258 49.3189V11.4215C23.4258 10.9667 23.8151 10.5977 24.2967 10.5977C24.7783 10.5977 25.1676 10.9667 25.1676 11.4215V49.3189C25.1676 49.7737 24.7783 50.1427 24.2967 50.1427Z",
    fill: "#373A3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8787 50.1427C33.3971 50.1427 33.0078 49.7737 33.0078 49.3189V11.4215C33.0078 10.9667 33.3971 10.5977 33.8787 10.5977C34.3604 10.5977 34.7497 10.9667 34.7497 11.4215V49.3189C34.7497 49.7737 34.3604 50.1427 33.8787 50.1427Z",
    fill: "#373A3D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4569 50.1427C42.9752 50.1427 42.5859 49.7737 42.5859 49.3189V11.4215C42.5859 10.9667 42.9752 10.5977 43.4569 10.5977C43.9385 10.5977 44.3278 10.9667 44.3278 11.4215V49.3189C44.3278 49.7737 43.9385 50.1427 43.4569 50.1427Z",
    fill: "#373A3D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9104 22.1282H13.8475C13.3659 22.1282 12.9766 21.7591 12.9766 21.3043C12.9766 20.8496 13.3659 20.4805 13.8475 20.4805H53.9104C54.3921 20.4805 54.7814 20.8496 54.7814 21.3043C54.7814 21.7591 54.3921 22.1282 53.9104 22.1282Z",
    fill: "#373A3D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9104 31.1946H13.8475C13.3659 31.1946 12.9766 30.8255 12.9766 30.3707C12.9766 29.916 13.3659 29.5469 13.8475 29.5469H53.9104C54.3921 29.5469 54.7814 29.916 54.7814 30.3707C54.7814 30.8255 54.3921 31.1946 53.9104 31.1946Z",
    fill: "#373A3D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9104 40.2532H13.8475C13.3659 40.2532 12.9766 39.8841 12.9766 39.4293C12.9766 38.9746 13.3659 38.6055 13.8475 38.6055H53.9104C54.3921 38.6055 54.7814 38.9746 54.7814 39.4293C54.7814 39.8841 54.3921 40.2532 53.9104 40.2532Z",
    fill: "#373A3D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_21513_23446",
    x: -5.95469,
    y: -6.31016,
    width: 78.8781,
    height: 78.0891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23446",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_b_21513_23446",
    x: -5.95469,
    y: 43.3812,
    width: 78.8781,
    height: 28.3977,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.15508
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_21513_23446"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_21513_23446",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMesh);
export default __webpack_public_path__ + "static/media/Mesh.f910b8bdc137103d5148d3ce3c4021e3.svg";
export { ForwardRef as ReactComponent };